export enum SubscriptionMessageType {
    PROJECT_STEP_STATUS = "orchestratorEvent",
    ACTION_COMPLETED = "actionCompleted",
    PROJECT_STEP_DONE = "orchestratorEventDone"
}

export enum SubscriptionMessageStatusType {
    COMPILE,
    RUNNING,
    DONE
}

export type ProjectUpdatedMessage = {
    actionId?: string;
    runtimeStatus: string;
    reason?: string;
    error?: string;
    projectOutput?: string;
    actionCompletedOutput?: Array<any>;
    skipped?: string;
    canceled?: string;
};

export type SubscriptionMessage = {
    type: SubscriptionMessageType;
    projectState?: SubscriptionMessageStatusType;
    inProgress?: boolean;
    message?: string;
    error?: string;
    projectUpdatedMessage?: ProjectUpdatedMessage;
};

export type ProjectListItem = {
    actionId?: string;
    status?: string;
    results?: Array<any>;
};

export type ProjectRunStatus = "done" | "error" | "running" | "";
